const revenueAttributionMethods = {
  hours: { id: 'hours', name: 'Percentage of Billable Hours' },
  services_cost: { id: 'services_cost', name: 'Percentage of Services Cost' },
  tm_basis: { id: 'tm_basis', name: 'Percentage of Time & Materials Revenue' },
};

export default revenueAttributionMethods;
